// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1XB6K","list":"PatternAutocomplete_list__2kS3U"};